export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-03A.7f56f3bb.png";